<template>
  <transition name="fade">
  <div class="question quesiton-number box box-shadow">

    <div class="question--question" v-html="question"></div>

    <transition name="slide-fade">
      <div>
        <div v-if="error" class="alert alert-danger" role="alert">
          {{error}}
        </div>
      </div>
    </transition>
    
    <div class="answer">
      <button class="plus" v-on:click="plus">+</button>
      <input 
        class="form-control" 
        type="text" 
        v-bind:value="value"
        v-on:input="doUpdate" 
        placeholder="Provide number"
        min="0"
      />
      <button class="minus" v-on:click="minus">-</button>
    </div>
    <footer>Q ID: {{id}} : {{index}}</footer>
  </div>
  </transition>
</template>

<script>

import Question from '@/components/questions/Question'
export default {
  name: 'Number',
  extends: Question,
  data: function () {
    return {
      error: null
    }
  },
  methods: {
    doUpdate ($event) {
      this.validateInput($event.target.value)
    },
    plus: function () {
      this.validateInput(Number(this.value) + 1)
    },
    minus: function () {
      if (Number(this.value) - 1 < 0) return
      this.validateInput(Number(this.value) - 1)
    },
    validateInput: function (value) {
      this.error = null
      if (isNaN(Number(value))) {
        this.error = 'Please type a number'
        this.$emit('input', null)
      } else {
        this.$emit('input', Number(value))
      }
    }
  }
}
</script>

<style scoped>
    .answer{
    max-width: 250px;
    margin: 2rem auto;
    position: relative;
    }
  input{
    margin: 2rem auto 0 !important;
    display: block !important;
    width: 250px;
  }
  button {
    position: absolute;
    top: 4px;
    left: 4px;
    color: #FF8708;
    padding: 7px 14px;
    background: white;
    border: 1px solid #FF8708;
    font-weight: bold;
    max-width: 38px;
    max-height: 37px;
  }

  .plus{
    right: 4px;
    left: inherit;
  }

  input {
    text-align: center;
  }
  .alert{
    margin: 1rem auto;
  }
</style>
 


// WEBPACK FOOTER //
// src/components/questions/Number.vue